import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import lightTheme from './theme/lightTheme';
import darkTheme from './theme/darkTheme';
import AppShell from './components/layout/AppShell';
import { useGuideIndex } from './hooks/useGuides';
import useGuideStore from './store/useGuideStore.ts'

function AppContent() {
  useGuideIndex();
  return <AppShell />;
}

export default function App() {
    const { themeMode } = useGuideStore();
    const theme = themeMode === 'dark' ? darkTheme : lightTheme;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppContent />
    </ThemeProvider>
  );
}
